
angular.module('mtic.components.mticAlertModal')
.service('MticAlertModalService', function(
    $log, 
    language
){
    var message = '';
    const showing = false;
    const defaultOptions = {
      isLang: false,
      callback: null,
      ask: false,
      title: null
    };
    this.options = angular.copy(defaultOptions);

    this.getMessage = () => {
        if(this.options.isLang) {
            return language.get(message);
        }
        else{
            return message;
        }
    }
    this.set = (value, newOptions) => {
        this.options = angular.extend(
          angular.copy(defaultOptions),
          newOptions
        )
        message = value;
        document.getElementById('mticAlertModal').style.display = 'block'
    }

    this.onExit = (saidYes) => {
      if(this.options.callback) {
        this.options.callback(saidYes)
      }
      document.getElementById('mticAlertModal').style.display = 'none'
    }
})
